const common = require('./common/constants')
const multipleAssessmentReport = require('./multipleAssessmentReport')
const domainAnalysisReport = require('./domainAnalysisReport')

module.exports = {
  common,
  multipleAssessmentReport,
  domainAnalysisReport,
}
